"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndeterminateIcon = exports.IdleIcon = exports.CheckedIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var IdleIcon = function IdleIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    height: "16",
    width: "16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  });
};
exports.IdleIcon = IdleIcon;
var CheckedIcon = function CheckedIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '8px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '8px' : _ref$height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 8 8",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12594 7.84713C2.84177 7.84713 2.62648 7.74379 2.44133 7.5242L0.219591 4.85466C0.0559742 4.66952 0 4.5059 0 4.31645C0 3.89449 0.318622 3.58448 0.749193 3.58448C0.998924 3.58448 1.17976 3.67059 1.34338 3.86866L3.10872 6.03442L6.59634 0.540345C6.77287 0.260475 6.95802 0.152832 7.25081 0.152832C7.68138 0.152832 8 0.462843 8 0.880496C8 1.0355 7.95264 1.20342 7.83638 1.37996L3.82777 7.48975C3.66416 7.73087 3.43165 7.84713 3.12594 7.84713Z"
  }));
};
exports.CheckedIcon = CheckedIcon;
var IndeterminateIcon = function IndeterminateIcon(_ref2) {
  var _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? '8px' : _ref2$width,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? '8px' : _ref2$height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 8 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "8",
    height: "2",
    rx: "1",
    fill: "white"
  }));
};
exports.IndeterminateIcon = IndeterminateIcon;